import stickyTopAds from './components/stickyTopAds'
import lazyload from './components/lazyload';
import offCanvas from './components/offcanvas';
import modal from './components/modal'
import refresh from './components/refresh';
import gallery from './components/gallery';
// import loadMore from './components/load-more';
// import utils from './components/utils';
// import toggleMenu from './components/toggle-menu';
// import openComments from './components/open-comments'
// import refreshTabBrowser from './components/refresh-tab-browser';

// Spritemap é gerado via SVGSpritemapPlugin; não é necessário importar SVG aqui


// // SVGS
// function requireAll (r) {
//   r.keys().forEach(r)
// }
// requireAll(require.context('../svg', true, /\.svg$/))

document.addEventListener('DOMContentLoaded', function () {
  // stickyTopAds.init();
  lazyload.init();
  offCanvas.init();
  modal.init();
  refresh.init();
  gallery.init();
  // refreshTabBrowser.init();
  // utils.init();
  // toggleMenu.init();
  // openComments.init();
  // loadMore.init();
});
